/**
 * Parent status roll-up (card UD7blPRrNa0C).
 *
 * When every sub-activity of a parent shares ONE status and the parent is not
 * already in it, the app offers (never forces) to move the parent to that status.
 * This pure helper is the single rule every surface uses — the web prompt after a
 * child status change, the parent banner, and the field prompt.
 *
 * Pass the parent's status id and the children's status ids as they are AFTER
 * the change, plus isTerminal (activity_statuses.is_terminal lookup). Returns
 * the shared child status id, or null when there are no children, the children
 * differ (or any child has no status), the parent already has that status, or
 * the parent is in a terminal status (Completed, On Hold) and the shared status
 * is not terminal — we never suggest moving a parent OUT of a terminal status.
 */
export function getParentRollupStatusId(
  parentStatusId: string | null | undefined,
  childStatusIds: ReadonlyArray<string | null | undefined>,
  isTerminal: (statusId: string) => boolean,
): string | null {
  if (childStatusIds.length === 0) {return null;}
  const shared = childStatusIds[0];
  if (!shared) {return null;}
  if (childStatusIds.some((s) => s !== shared)) {return null;}
  if (shared === parentStatusId) {return null;}
  if (parentStatusId && isTerminal(parentStatusId) && !isTerminal(shared)) {return null;}
  return shared;
}
